import Client from '@/api/client'
import { getConfig } from '@/app/config'
import { Language, Salutation } from '@/features/auth'

const client = new Client(getConfig().API_ENDPOINT ?? '')

const userServiceShipUsersPath = '/api/user-service/api/ship-users'

export type UpdateUserProps = {
  firstName: string
  lastName: string
  salutation?: Salutation
  title?: string
  phoneLandline?: string
  phoneMobile?: string
  languages?: Language[]
}

export const updateUser = async (props: UpdateUserProps): Promise<void> => {
  await client.put(`${userServiceShipUsersPath}/profile`, props)
}

export type UpdatePreferredLanguageProps = {
  preferredLanguage: Language
}

export const updatePreferredLanguage = async (props: UpdatePreferredLanguageProps): Promise<void> => {
  await client.patch(`${userServiceShipUsersPath}/preferred-language`, props)
}

export type UpdateEmailProps = {
  email: string
}

export const updateEmail = async (props: UpdateEmailProps): Promise<void> => {
  await client.post(`${userServiceShipUsersPath}/send-email-verification`, {
    email: props.email,
    redirectTo: window.location.origin,
  })
}

export type VerifyEmailProps = {
  digest: string
}

export const verifyEmail = async (props: VerifyEmailProps): Promise<void> => {
  await client.post(`${userServiceShipUsersPath}/verify-email?digest=${props.digest}`)
}

export type UpdatePasswordProps = {
  currentPassword: string
  password: string
}

export const updatePassword = async (props: UpdatePasswordProps): Promise<void> => {
  await client.patch(`${userServiceShipUsersPath}/password`, props)
}

export const isCurrentPassswordError = (error: unknown): boolean =>
  error instanceof Error && error.message === 'The current password is not correct'

export const isReusedPasswordError = (error: unknown): boolean =>
  error instanceof Error && error.message === 'The new password cannot be the same as the old password.'
